export enum OrderTypeEnum {
  Referral = 1,
  ReferralAddendum = 2,
  PlanOfCareUpdate = 5,
  Hold = 6
}

export const OrderTypeOptions = [
{ id: 1, label: 'Referral' },
{ id: 2, label: 'Referral Addendum' },
{ id: 5, label: 'Plan Of Care Update' },
{ id: 6, label: 'Hold' }
];
